import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link,useNavigate } from 'react-router-dom';
import AuthUser from "../../AuthUser";
import MainLoader from "../Loaders/MainLoader";
import CopyToClipboard from 'react-copy-to-clipboard';


function AddShipmentManifest(){
    const navigate = useNavigate();
    const [defaultCountry, setDefaultCountry] = useState('');
    const [countrylist, setCountrylist] = useState([]);
    const [citylist, setCitylist] = useState([]);
    const [hublist, setHublist] = useState([]);
    const [selectedFromCountry, setSelectedFromCountry] = useState('');
    const [selectedFromCity, setSelectedFromCity] = useState('');
    const [selectedToCountry, setSelectedToCountry] = useState('');
    const [selectedToCity, setSelectedToCity] = useState('');
    const [shipmentlist, setShipmentlist] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [selectedHub, setSelectedHub] = useState('');
    const [selectedOption, setSelectedOption] = useState('Domestic');
    const [selecteddate, setSelecteddate] = useState(getTodayDateString());
    const{headers1,headers2,logout}=AuthUser();
    const [Loading, setLoading] = useState(true);
    const [BtnLoading, setBtnLoading] = useState(false);
    const [Btn1Loading, setBtn1Loading] = useState(false);
    const [transport, setTransport] = useState(false);
    const [transportname, setTransportname] = useState('');
    const [transportcharge, setTransportcharge] = useState('');
    const [transportvehicleno, setTransportvehicleno] = useState('');
    const [transportdrivername, setTransportdrivername] = useState('');
    const [transportdrivermobileno, setTransportdrivermobileno] = useState('');
    const [flightname, setFlightname] = useState('');
    const [flightno, setFlightno] = useState('');
    const [userdata, setUserdata] = useState('');
    const [transporterlist, setTransporterlist] = useState([]);
    const courierselected = JSON.parse(localStorage.getItem('courierselectedoption'));

    useEffect(()=>{
        GetCountrylist();
        Gettransporter();
        GetdefaultCountry();
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
         setUserdata(items);
        }
    },[]);

    const Gettransporter=()=>
    {
        axios({
            method: 'post',
            url: Global.baseUrl+'AllTransporter',
            headers:headers1,
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setTransporterlist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
    }

    const GetdefaultCountry=()=>
    {
        axios({
            method: 'post',
            url: Global.baseUrl+'defaultcountryname',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setDefaultCountry(data);
                setSelectedFromCountry(data);
                setSelectedToCountry(data);
                GetCityList(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
    }

    const GetCountrylist=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Countrylist',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCountrylist(data);
            }
            setLoading(false);
          })
          .catch(function (error) {
            // console.log(error);
            setLoading(false);
          });
    }
    const GetCityList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Citylist',
            data: {
                name: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCitylist(data);
            }
            else
            {
                setCitylist([]);
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
    }

   
     // Handle Hub selection
     const handleHubChange = (event) => {
        setSelectedHub(event.value);
    };

    const GenrateShipmentManifest=()=>{
        if(checkedItems =='')
        {
            toast.warn('Please Select At Least One Shipment!');
        }
        else
        {
            setBtnLoading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'AddShipmentManifest',
                headers:headers1,
                data: {
                    usertype:userdata.usertype,
                    userid:userdata.id,
                    slip_no: checkedItems,
                    mfrom: selectedFromCity,
                    mto: selectedToCity,
                    mto_hub:selectedHub, 
                    mdate: selecteddate,
                    manifest_type:selectedOption,
                    transportname:transportname,
                    transportcharge:transportcharge,
                    transportvehicleno:transportvehicleno,
                    transportdrivername:transportdrivername,
                    transportdrivermobileno:transportdrivermobileno,
                    flightname:flightname,
                    flightno:flightno,
                    courierselected: courierselected

                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                    setTimeout(() => {
                        navigate('/ShipmentManifestList/Running');
                      }, 1000);
                }
                else
                {
                    toast.error(response.data.message);
                }
                setBtnLoading(false);
            })
            .catch(function (error) {
                setBtnLoading(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
        }
    }

    // Function to handle Radio change
    const handleOptionChange = (event) => {
        const val = event.target.value;
        setSelectedOption(val);
        if(val == 'Domestic')
        {
            GetdefaultCountry();
            window.location.reload();
        }
        else
        {
            GetdefaultCountry();
            setCitylist([]);
            // setHublist([]);
        }
        // setSelectedToCountry('');
        // setSelectedFromCountry('');
        setSelectedFromCity('');
        setSelectedToCity('');
        setSelectedHub('');
        setHublist([]);
      };

       // Handle From country selection
    const handleFromCountryChange = (event) => {
        const countryname = event.target.value;
        setSelectedFromCountry(event.target.value);
        GetCityList(countryname);
    };
     // Handle From city selection
     const handleFromCityChange = (event) => {
        setSelectedFromCity(event.value);
        
    };
      // Handle To country selection
      const handleToCountryChange = (event) => {
        const countryname = event.target.value;
        setSelectedToCountry(event.target.value);
        GetCityList(countryname);
    };
     // Handle To city selection
     const handleToCityChange = (event) => {
        const cityid = event.value;
        setSelectedToCity(event.value);
        GetHubList(cityid);
    };

    // Function to get today's date in the format "YYYY-MM-DD"
    function getTodayDateString() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }

    const GetHubList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Hublist',
            data: {
                cityid: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setHublist(data);
            }
          })
          .catch(function (error) {
            // console.log(error);
          });
    }

    const GetShipmets=()=>{
        if(selectedFromCountry =='' && selectedOption =='International' && userdata.usertype !='M')
        {
            toast.warn('Please Select Form Country!')
        }
        else if(selectedFromCity =='')
        {
            toast.warn('Please Select Form City!')
        }
        else if(selectedToCountry =='' && selectedOption =='International')
        {
            toast.warn('Please Select To Country!')
        }
        else if(selectedToCity =='')
        {
            toast.warn('Please Select To City!')
        }
        else if(selectedHub =='')
        {
            toast.warn('Please Select Hub!')
        }
        else if(selecteddate =='')
        {
            toast.warn('Please Select Shipment Date!')
        }
        else
        {
            setBtn1Loading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'GetShipmentlist',
                headers:headers1,
                data: {
                    mfrom: selectedFromCity,
                    mto: selectedToCity,
                    usertype:userdata.usertype,
                    userid:userdata.id,
                    shipmenttype:selectedOption,
                    courierselected: courierselected
                }
            })
            .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data.value;
                    setTransport(true);
                    setShipmentlist(data);
                }
                else
                {
                    setShipmentlist([]);
                }
                setBtn1Loading(false);
            })
            .catch(function (error) {
                setBtn1Loading(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
              });
        }
    }

    const handleChange = (event) => {
        const slipno = event.target.value;
        if(!checkedItems.includes(slipno)){
            setCheckedItems([...checkedItems,slipno]);
        }else{
            let arr=checkedItems.filter((item)=>item!==slipno);
            setCheckedItems(arr);
        }
        
      };

      const handleSelectAllChange = (event) => {
        if (event.target.checked) {
            const allSlipNos = shipmentlist.map(item => item.slip_no);
            setCheckedItems(allSlipNos);
        } else {
            setCheckedItems([]);
        }
    };
    const handlescan=(e)=>{
        const slip_no = e.target.value;
        let tempShipment = shipmentlist.map((ship) => {
            if (ship.slip_no === slip_no) {
                if (!checkedItems.includes(slip_no)) {
                    setCheckedItems([...checkedItems, slip_no]);
                }
            }
        });
    }
    
    const isChecked = (slip_no) => checkedItems.includes(slip_no);

    const handleTransporterChange = (id) => {
        if (!id) return;

        const selectedTransporter = transporterlist.find(
            (t) => String(t.id) === String(id)
        );
        setTransportname(selectedTransporter.vehicle_type);
        setTransportvehicleno(selectedTransporter.vehicle_no);
        setTransportdrivername(selectedTransporter.name);
        setTransportdrivermobileno(selectedTransporter.mobile);

    };

    return(
        <>
        <LeftPanel/>
        <main className='home-section'>
            <Header/>
            <ToastContainer/>
            {Loading==true ?<MainLoader/>:
            <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                            <li className="breadcrumb-item">
                                <a href="/Admin-Dash">
                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">Manifest Management</li>
                        </ol>
                    </nav>
                    <div className="d-flex justify-content-between">
                        <div className="">
                            <button className="btn btn_nav btn-sm" onClick={() => navigate(-1)}>
                            <i className="bx bx-arrow-back "></i>
                            </button>
                        </div>
                        <div className="ps-2 ">
                            <h2 className="h4">Generate Shipment Manifest</h2>
                        </div>
                    </div>
                </div>
                
                <div className="btn-toolbar mb-2 mb-md-0">
                </div>
            </div>

            <div className="card mb-3">
              <div className="card-body">
                <div className="row">
                    <div className="col-12 col-md-12 mb-3">
                        <div><label htmlFor="email" className="form-label">Mode: <span className="text-danger">*</span></label></div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Domestic" checked={selectedOption === 'Domestic'} onChange={handleOptionChange} />
                          <label className="form-check-label" htmlFor="inlineRadio1">Domestic</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="International" checked={selectedOption === 'International'} onChange={handleOptionChange} />
                          <label className="form-check-label" htmlFor="inlineRadio2">International</label>
                        </div>
                        {/* <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="HyperLocal" checked={selectedOption === 'HyperLocal'} onChange={handleOptionChange} />
                          <label className="form-check-label" htmlFor="inlineRadio3">Hyper Local</label>
                        </div> */}
                    </div>
                    {selectedOption !='Domestic' && userdata.usertype !='M' ?
                    <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">From Country: <span className="text-danger">*</span></label></div>
                        <select className="form-select" onChange={handleFromCountryChange}>
                          <option value="">-- Please Select --</option>
                          {countrylist.map((list,i)=>{
                            return (
                            <option value={list.country} selected={list.country == defaultCountry} key={i}>{list.country}</option>
                            );
                            })}
                        </select>
                    </div>
                    :
                    ""
                    }
                    <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">From City: <span className="text-danger">*</span></label></div>
                        {userdata.usertype !='M' ?
                        <Select
                        // defaultValue={selectedOption} 
                        onChange={handleFromCityChange}
                        options={citylist} 
                        placeholder="Enter city name"
                        />
                        :
                        <select className="form-select" onChange={(e)=>handleFromCityChange(e.target)}>
                            <option value="">-- Please Select --</option>
                            <option value={userdata.branch_location}>{userdata.cityname}</option>
                        </select>
                        }
                    </div>
                    {selectedOption !='Domestic' &&
                    <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">To Country: <span className="text-danger">*</span></label></div>
                        <select className="form-select" onChange={handleToCountryChange}>
                          <option value="">-- Please Select --</option>
                          {countrylist.map((list,ai)=>{
                            return (
                            <option value={list.country} selected={list.country == defaultCountry} key={ai}>{list.country}</option>
                            );
                            })}
                        </select>
                    </div>
                    }
                    <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">To City: <span className="text-danger">*</span></label></div>
                        <Select
                        // defaultValue={selectedOption} 
                        onChange={handleToCityChange}
                        options={citylist} 
                        placeholder="Enter city name"
                        />
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <div className="d-flex justify-content-between">
                            <div ><label htmlFor="email" className="form-label">Select HUB: <span className="text-danger">*</span></label> </div>
                            <div><small className=""><Link to={`/HubAdd`} target="_blank" tabIndex={-1} className="text-muted">Add New HUB</Link></small></div>
                        </div>
                        <Select
                        // defaultValue={selectedOption} 
                        onChange={handleHubChange}
                        options={hublist} 
                        placeholder="Select Hub"
                        />
                    </div>
                    <div className="col-12 col-md-4 mb-3">
                        <div><label htmlFor="email" className="form-label">Date: <span className="text-danger">*</span></label></div>
                        <input type="date" className="form-control" id="text" value={selecteddate} placeholder="Enter city name" onChange={(e)=>setSelecteddate(e.target.value)} />
                    </div>
                    <div className="col-md-12"></div>
                    {Btn1Loading==false?
                    <div className="d-grid col-md-2 mt-2">
                        <button onClick={()=>GetShipmets()} className="btn btn-primary">View Shipment</button>
                    </div>
                    :
                    <div className="d-grid col-md-2 mt-2">
                        <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
                    </div>
                    }
                </div>
              </div>
            </div>

            { transport == true &&
            <div className="card mb-3">
                <div className="card-body">
                  <label htmlFor="email" className="form-label">Scan Shipment #:</label>
                  <div className="input-group">
                      <span className="input-group-text" id="basic-addon1">
                          <i className="bx bx-search"></i>
                      </span>
                      <input type="text" className="form-control" onChange={handlescan} placeholder="Scan Shipment Number" aria-label="Search" />
                  </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <label htmlFor="email" className="form-label">Transporter Detail #:</label>
                        <div className="col-6">
                            <select className="form-select" onChange={(e)=>handleTransporterChange(e.target.value)}>
                                <option value="">-- Please Select --</option>
                                {transporterlist.map((list) => (
                                    <option key={list.id} value={list.id}>
                                    {list.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-6">
                            <input type="text" className="form-control" placeholder="Enter Transporter" aria-label="Transport Charge" value={transportname} onChange={(e)=>setTransportname(e.target.value)} />
                        </div>
                        <div className="col-6 mt-3">
                            <input type="text" className="form-control" placeholder="Transport Charge" aria-label="Transport Charge" value={transportcharge} onChange={(e)=>setTransportcharge(e.target.value)} />
                        </div>
                        <div className="col-4 mt-3">
                            <input type="text" className="form-control" placeholder="Enter Vehicle No." aria-label="Enter Vehicle No." value={transportvehicleno} onChange={(e)=>setTransportvehicleno(e.target.value)} />
                        </div>
                        <div className="col-4 mt-3">
                            <input type="text" className="form-control" placeholder="Enter Driver Name" aria-label="Enter Driver Name" value={transportdrivername} onChange={(e)=>setTransportdrivername(e.target.value)} />
                        </div>
                        <div className="col-4 mt-3">
                            <input type="text" className="form-control" placeholder="Enter Driver Mobile No." aria-label="Enter Driver Mobile No." value={transportdrivermobileno} onChange={(e)=>setTransportdrivermobileno(e.target.value)} />
                        </div>
                        
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <label htmlFor="email" className="form-label">Flight Detail #:</label>
                        <div className="col-6">
                            <input type="text" className="form-control" placeholder="Enter Flight Company Name." aria-label="Enter Flight Company Name." value={flightname} onChange={(e)=>setFlightname(e.target.value)} />
                        </div>
                        <div className="col-6">
                            <input type="text" className="form-control" placeholder="Enter Flight No." aria-label="Enter Flight No." value={flightno} onChange={(e)=>setFlightno(e.target.value)} />
                        </div>
                    </div>
                </div>
            </div>
            }

            <section className="data_table">
                <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                    <table className="table table-hover">
                        <thead>
                             <tr>
                                <th className="border-gray-200" style={{"width": "20px"}}>
                                {shipmentlist !=undefined ?
                                    <input className="form-check-input" type="checkbox" onChange={handleSelectAllChange}  checked={checkedItems.length === shipmentlist.length}/>
                                :
                                ''
                                }
                                </th>						
                                {courierselected =='B2B' ?
                                <th className="border-gray-200">LR NO #</th>
                                :
                                <th className="border-gray-200">AWB #</th>
                                }
                                <th className="border-gray-200">Date</th>
                                <th className="border-gray-200">Origin</th>
                                <th className="border-gray-200">Destination</th>
                                <th className="border-gray-200">Sender</th>
                                <th className="border-gray-200">Receiver</th>
                            </tr>
                        </thead>
                        <tbody>
                    {shipmentlist.length>0 ?
                            <>
                        {shipmentlist.map((shi,index) =>{
                                return(
                                <tr key={index}>
                                    <td style={{"width": "20px"}}>
                                        <input className="form-check-input" type="checkbox" id={index} value={shi.slip_no} checked={isChecked(shi.slip_no)} onChange={handleChange} />
                                    </td>
                                    <td>
                                        <div>
                                            <Link target="_blank" to={`/ShipmentDetails/${shi.slip_no}`} className="fw-bold">{shi.slip_no}</Link>
                                            <CopyToClipboard text={shi.slip_no} onCopy={()=>{toast.success(shi.slip_no+' Copied To Clipboard')}}>
                                                <i className="bx bx-copy"></i>
                                            </CopyToClipboard>
                                        </div>
                                    </td>
                                    <td><span className="fw-normal text-capitalize"><small>{shi.entrydate}</small></span></td>
                                    <td><span className="fw-normal text-capitalize">{shi.sendercity}, {shi.sendercountry}</span></td>
                                    <td>
                                        <span className="fw-normal text-capitalize">{shi.receivercity}, {shi.receivercountry}</span>
                                    </td>
                                    <td>
                                        <span className="fw-normal text-capitalize">{shi.sender_name}</span>
                                    </td>
                                    <td>
                                        <span className="fw-normal text-capitalize">{shi.reciever_name}</span>
                                    </td>
                                </tr>
                                );
                            })} 
                        </> 
                        :
                        <tr>
                            <td colSpan="7" className="text-center text-danger">Record Not Found</td>
                        </tr>
                            }                      
                        </tbody>
                    </table>
                    
                </div>
            </section> 
            <div className="col-md-12"></div>
            {BtnLoading==false?
            <div className="d-grid col-md-2 mt-2">
                <button onClick={()=>GenrateShipmentManifest()} className="btn btn-primary">Generate Manifest</button>
            </div>
            :
            <div className="d-grid col-md-2 mt-2">
                <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
            </div>
            }
            
            </>}
            <Footer/>
        </main>
        </>

    );
}
export default AddShipmentManifest;